import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { FaFlag, FaPhoneAlt, FaPlay } from 'react-icons/fa';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import Certifications from '../Components/Certifications';
import ContentFooter from '../Components/ContentFooter';
import Educations from '../Components/Educations';
import Experiences from '../Components/Experiences';
import LanguagesSpoken from '../Components/LanguagesSpoken';
import Skills from '../Components/Skills';
import styles from '../Content/Home.module.css'
import { BASE_URL_API } from '../References/URLs';

const Home = () => {
    const params = useParams()
    const { userIdentifier } = params
    const [isLoading, setIsLoading] = useState(false)
    const [resumeData, setResumeData] = useState(null)
    const [isUrlValid, setIsUrlValid] = useState(true)

    const getResume = async () => {
        setIsLoading(true)
        const getResumeResponse = await fetch(BASE_URL_API + "getResume",
            {
                method: "POST",
                body: JSON.stringify({
                    userIdentifier: userIdentifier
                })
            });

        if (!getResumeResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getResumeRespo = await getResumeResponse.json()
            if (getResumeRespo.status === "success") {
                setIsUrlValid(true)
                setResumeData(getResumeRespo.response)
            } else {
                setIsUrlValid(false)
                setResumeData(null)
            }
            console.log(getResumeRespo)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getResume()
    }, [userIdentifier])

    let p = `I'm a professional ${resumeData?.primaryDetails?.pwd}`
    if (resumeData?.primaryDetails?.swd !== "") {
        p = p.concat(` cum ${resumeData?.primaryDetails?.swd}`)
    }
    if (resumeData?.primaryDetails?.twd !== "") {
        p = p.concat(` cum ${resumeData?.primaryDetails?.twd}`)
    }
    p = p.concat(`. I'm ${resumeData?.primaryDetails?.age} years old, ${resumeData?.primaryDetails?.gender} with `)
    p = p.concat(resumeData?.executiveSummary)
    p = p.concat(`Have a look at my resume on stylelink. If you like my profile you can hire me from stylelink. Thanks`)


    return (
        <div className={styles.mainWrapper}>
            {isUrlValid === true ?
                <div className={styles.mainContainer}>
                    {/* <div className={styles.mainHeaderWrapper}>
                    Navneet Chandan
                </div> */}
                    <Helmet>
                        <title>{`Hey, I'm ${resumeData?.primaryDetails?.fullName} is available on Stylelink.`}</title>
                        <meta name="description" content={`Hey, I'm ${resumeData?.primaryDetails?.fullName} is available on Stylelink - India's best app for salon/makeup courses &amp; jobs`}></meta>

                        <meta property="og:title" content={`Hey, I'm ${resumeData?.primaryDetails?.fullName} is available on Stylelink.`} />
                        <meta property="og:description" content={p} />
                        <meta property="og:image" content={resumeData?.primaryDetails?.dp} />

                    </Helmet>
                    <div className={styles.mainBodyWrapper}>
                        <div className={styles.bodyContainers}>
                            <div className={styles.upperProfileWrapper}>
                                <div className={styles.upperProfileFloor}>

                                </div>
                                <div className={styles.upperProfileLayer}>
                                    <div className={styles.uplImageWrapper}>
                                        <img
                                            src={resumeData?.primaryDetails?.dp}
                                            alt="dp"
                                        />
                                    </div>
                                    <div className={styles.uplNameWrapper}>
                                        <div className={styles.fullName}>{resumeData?.primaryDetails?.fullName}</div>
                                        <div className={styles.ageGender}>{resumeData?.primaryDetails?.age} years old, {resumeData?.primaryDetails?.gender}</div>
                                        <div className={styles.professionTitle}>
                                            {resumeData?.primaryDetails?.pwd} {resumeData?.primaryDetails?.swd !== "" && `&`} {resumeData?.primaryDetails?.swd} {resumeData?.primaryDetails?.twd !== "" && `&`} {resumeData?.primaryDetails?.twd}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.summaryWrapper}>
                                <div className={styles.summaryContainer}>
                                    <div className={styles.videoExpWrapper} >
                                        <div className={styles.videoWrapper}>
                                            <div className={styles.thumbnailContainer}>
                                                <div className={styles.thumbnailIcon}>
                                                    {/* <img src="https://static.vecteezy.com/system/resources/previews/023/527/510/original/verified-checkmark-sign-icon-symbol-logo-green-design-transparent-background-free-png.png" /> */}
                                                    <img src="https://upload.wikimedia.org/wikipedia/commons/4/47/Asif_Raihan_verified.png" alt="thumbnail" />
                                                </div>
                                                <div className={styles.videoPlayIconWrapper}>
                                                    <div className={styles.videoPlayIcon}>
                                                        <FaPlay size={20} color="#ffffff99" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={styles.expTxtWrapper}>
                                            {resumeData?.executiveSummary}
                                        </div>
                                    </div>
                                    <div className={styles.contentWrapper}>
                                        {resumeData?.primaryDetails?.description}
                                    </div>
                                </div>
                            </div>

                            <Experiences
                                data={resumeData?.workExperience}
                            />

                            <Skills
                                data={resumeData?.skillset}
                            />

                            {resumeData?.certificate !== null &&
                                <Certifications
                                    data={resumeData?.certificate}
                                />
                            }

                            <LanguagesSpoken
                                data={resumeData?.languageSpoken}
                            />

                            <Educations
                                data={resumeData?.educationQuali}
                            />


                            <div className={styles.reportProfileWrapper}>
                                <div className={styles.getMyCvWrapper}>
                                    <div className={styles.getMyCvTitle}>
                                        Are you a stylist?
                                    </div>
                                    <div className={styles.getMyCvTxt}>
                                        If you also belong to beauty / salon line, you can also get your cv like this.
                                        Just download the stylelink App or give us a missed call on
                                    </div>
                                    <div className={styles.callusOn}>
                                        <FaPhoneAlt color="#ffffff74" /> &nbsp; <a href="tel:+91-8287098287">8287-09-8287</a>
                                    </div>
                                </div>
                                <div className={styles.reportProfileContainer}>
                                    <FaFlag size={16} color="#ffffff75" /> &nbsp; Report this profile.
                                </div>
                            </div>

                            <ContentFooter

                            />

                        </div>
                    </div>
                    <div className={styles.mainFooterWrapper}>
                        <div className={styles.actionBtnWrapper}>
                            <Link to={`/${userIdentifier}/share`} className={styles.shareBtn}>Share</Link>
                            <button className={styles.hireBtn}>
                                <a href={`tel:+91-${resumeData?.primaryDetails?.phone}`}>
                                    {resumeData?.primaryDetails?.phone}
                                </a>
                            </button>
                        </div>
                    </div>
                </div>
                :
                <div className={styles.mainContainer}>
                    <div className={styles.mainBodyWrapper}>
                        <div className={styles.upperProfileWrapper}>
                            <div className={styles.upperProfileFloor}>

                            </div>
                            <div className={styles.upperProfileLayer}>
                            </div>
                        </div>

                        <div className={styles.invalidWrapper}>
                            <div>
                                <img src="https://static.semrush.com/blog/uploads/media/4e/d9/4ed96ce4710c2dca552093773dd63ac7/broken-link-building.svg" />
                            </div>
                            <div className={styles.invalidResumeTxt}>
                                Invalid Resume
                            </div>
                            <div className={styles.callSupport}>
                                <a href="tel:+91-8448191903">Call Support</a>
                            </div>
                        </div>
                    </div>
                </div>
            }


        </div>
    )
}

export default Home